export default "__VITE_ASSET__yS74Oe59__"